module.exports = __webpack_public_path__ + "img/error_icon.ab276865.svg";